import { LinkButton as RLinkButton } from 'radiance-ui';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import styled from '@emotion/styled';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NavigationContainer = styled.div`
  margin: ${SPACER.large} 0;
`;

export const ButtonRow = styled.div`
  ${MEDIA_QUERIES.mdUp} {
    display: flex;
  }
`;

export const LinkButton = styled(RLinkButton)`
  margin: ${SPACER.medium};
`;
